import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { VentasMetodoPagoInterface } from "../interfaces/ventasMetodoPago.interface";


export async function getVentasPorMetodoPagoAction(
  fechaInicio?: string,
  fechaFin?: string
): Promise<ApiResponse<VentasMetodoPagoInterface>> {
  const { data } = await apiClient.get<VentasMetodoPagoInterface>(
    "reports/ventas/metodo-pago",
    { params: { fechaInicio, fechaFin } }
  );

  return {
    status: 200,
    data,
    message: "Ventas por método de pago obtenidas correctamente",
  };
}